/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import { useApolloClient } from '@apollo/client';
import { Icon } from '@mayoral/ui';
import { IconButton, styled, Tooltip } from '@mui/material';
import { logout } from '@utils/session';
import { useTranslation } from 'next-i18next';
import { FC } from 'react';

const SidebarLogoutIconButon = styled(IconButton, {
  name: 'SidebarLogoutButton',
  slot: 'IconButton',
})(({ theme }) => ({
  marginRight: theme.spacing(-1),
  width: theme.spacing(3.75),
  height: theme.spacing(3.75),
  color: theme.palette.dark[400],
  '&:hover': { color: theme.palette.error.main },
}));

const SidebarLogoutButton: FC = () => {
  const { t } = useTranslation();
  const client = useApolloClient();

  const handleLogout = () => {
    logout(client.cache);
  };

  return (
    <Tooltip title={t('CERRAR_SESION')} placement="top">
      <SidebarLogoutIconButon color="error" onClick={handleLogout}>
        <Icon name="LogoutS" sx={{ fontSize: 14 }} />
      </SidebarLogoutIconButon>
    </Tooltip>
  );
};

export default SidebarLogoutButton;
